<template>
  <div class="max-flex-layout-wrapper">
    <div
      :class="{
        'max-flex-layout-view': !bigView,
        'max-flex-layout-view-big': bigView,
      }"
    >
      <v-row v-if="props.layout.blocks" class="columns">
        <template
          v-for="(block, index) in props.layout.blocks"
          :key="props.layout.blocks[index].button"
        >
          <MaxFlexButton
            :id="props.layout.name"
            ref="blocks"
            :key-num="props.layout.blocks[index].button"
            :config="props.config"
            :name="block.name"
            :height="block.height"
            :width="block.width"
            :is-highlighted="isHighlighted"
          />
        </template>
      </v-row>
    </div>
  </div>
</template>

<script setup lang="ts">
import { onMounted, onUnmounted, Ref, ref } from 'vue'

import MaxFlexButton from '@/apps/brelag/mandator-user/components/editor/maxflex/MaxFlexButton.vue'

type MaxFlexLayoutViewProps = {
  layout: Ref<any>
  combinedHighlight?: boolean
  config?: any
  bigView?: boolean
}

const props = withDefaults(defineProps<MaxFlexLayoutViewProps>(), {
  combinedHighlight: true,
  config: null,
  bigView: false,
})

const blocks: Ref<any[]> = ref(null)
const isHighlighted: Ref<boolean> = ref(false)
const emit = defineEmits(['click'])

onMounted(() => {
  if (blocks.value) {
    blocks.value.forEach((block, index) => {
      const element = block.$el
      if (element) {
        if (props.combinedHighlight) {
          // We want to highlight all buttons of a layout if user hovers over one of the buttons
          element.addEventListener('mouseover', mouseOverHandler)
          element.addEventListener('mouseout', mouseOutHandler)
        }
        element.addEventListener('click', (event) => {
          const keyNum = props.layout.blocks[index]?.button
          clickHandler(event, keyNum)
        })
      }
    })
  }
})

function mouseOverHandler() {
  isHighlighted.value = true
}

function mouseOutHandler() {
  isHighlighted.value = false
}

function clickHandler(event, keyNum) {
  emit('click', props.layout.value, keyNum)
}

onUnmounted(() => {
  if (blocks.value) {
    blocks.value.forEach((block) => {
      const element = block.$el
      if (element) {
        if (props.combinedHighlight) {
          element.removeEventListener('mouseover', mouseOverHandler)
          element.removeEventListener('mouseout', mouseOutHandler)
        }
        element.removeEventListener('click', clickHandler)
      }
    })
  }
})
</script>

<style lang="scss" scoped>
.max-flex-layout-wrapper {
  padding-bottom: 80%;
  position: relative;
  height: 0;
}

.max-flex-layout-view {
  padding: 5px 5px 5px 5px;
  position: absolute;
  top: 0;
  left: 0;
  width: 120px;
  height: 120px;
}

.max-flex-layout-view-big {
  padding: 5px 5px 5px 5px;
  position: absolute;
  top: 0;
  left: 0;
  width: 370px;
  height: 370px;
}

.max-flex-layout-wrapper .columns {
  margin: 0;
  height: 100%;
}
</style>
